/**
 *
 *
 * @export
 * @class TeaserSlider
 */
export class TeaserSlider {
  private _explanationText = 'Entdecken Sie per Klick unsere Online-Welt';
  private _activeSlide = 0;
  private _rootElement: HTMLElement = document.querySelector('.ow-teaser');
  private _sliderElement: HTMLElement = this._rootElement.querySelector('.ow-teaser__slider');
  private _slides;

  /**
   *Creates an instance of TeaserSlider.
   * @memberof TeaserSlider
   */
  constructor() {
    this.events();
    this._sliderElement.insertAdjacentHTML('beforeend', this._sliderElement.innerHTML);
    this._slides = Array.from(this._sliderElement.children);
  }

  /**
   *
   *
   * @memberof TeaserSlider
   */
  public show(): void {
    this._sliderElement.classList.add('ow-teaser__slider--show');
  }

  /**
   *
   *
   * @memberof TeaserSlider
   */
  public hide(): void {
    this._sliderElement.classList.remove('ow-teaser__slider--show');
  }

  /**
   *
   *
   * @memberof TeaserSlider
   */
  public animate(): void {
    this.removeAllClassesFromSlideElements();
    //vorletzter Slide
    if (this._activeSlide + 2 === this._slides.length) {
      this.activeSlideHandler(this._activeSlide, this._activeSlide + 1, 0);
      this._slides[this._activeSlide - 1].classList.add('active-fade-out');
      this.removeFadeOutClass(this._slides[this._activeSlide - 1]);
    }
    //letzter Slide
    else if (this._activeSlide + 1 === this._slides.length) {
      this.activeSlideHandler(this._activeSlide, 0, 1);

      this._slides[this._activeSlide - 1].classList.add('active-fade-out');
      this.removeFadeOutClass(this._slides[this._activeSlide - 1]);
    } else {
      this.activeSlideHandler(this._activeSlide, this._activeSlide + 1, this._activeSlide + 2);
      this._slides[
        this._activeSlide === 0 ? this._slides.length - 1 : this._activeSlide - 1
      ].classList.add('active-fade-out');
      this.removeFadeOutClass(
        this._slides[this._activeSlide === 0 ? this._slides.length - 1 : this._activeSlide - 1]
      );
    }

    this.changeActiveSlidePlusOne();
  }

  /**
   *
   *
   * @private
   * @memberof TeaserSlider
   */
  private events(): void {
    this._sliderElement.addEventListener('mouseenter', () => {
      const infoText: HTMLSpanElement = document.createElement('span');
      infoText.classList.add('ow-teaser__slider-explanation');
      infoText.innerText = this._explanationText;
      this._sliderElement.querySelector('.active').insertAdjacentElement('afterbegin', infoText);
    });
    this._sliderElement.addEventListener('mouseleave', () => {
      this._sliderElement.querySelector('.ow-teaser__slider-explanation').remove();
    });
  }

  /**
   *
   *
   * @private
   * @param {number} $active
   * @param {number} $active_1
   * @param {number} $active_2
   * @memberof TeaserSlider
   */
  private activeSlideHandler($active: number, $active_1: number, $active_2: number): void {
    this._slides[$active].classList.add('active');
    this._slides[$active_1].classList.add('active-1');
    this._slides[$active_2].classList.add('active-2');
  }

  /**
   *
   *
   * @private
   * @memberof TeaserSlider
   */
  private changeActiveSlidePlusOne(): void {
    if (this._activeSlide + 1 === this._slides.length) {
      this._activeSlide = 0;
    } else {
      this._activeSlide++;
    }
  }

  /**
   * * Entfernt alle möglichen aktiven Stati von den Slide Elementen
   *
   *
   * @private
   * @memberof TeaserSlider
   */
  private removeAllClassesFromSlideElements(): void {
    for (let i = 0; i < this._slides.length; i++) {
      this._slides[i].classList.remove('active');
      this._slides[i].classList.remove('active-1');
      this._slides[i].classList.remove('active-2');
    }
  }

  /**
   * *Fade Out Klasse wird entfernt, damit bei Neueinblendung kein Transform Effekt entsteht
   *
   * @private
   * @param {HTMLElement} el
   * @memberof TeaserSlider
   */
  private removeFadeOutClass(el: HTMLElement): void {
    setTimeout(() => {
      el.classList.remove('active-fade-out');
    }, 1000);
  }
}
